import $, { event } from "jquery";
import { createPopper } from '@popperjs/core';

class Popover {
    constructor() {
        this.init();
    }

    init() {
        this.dom();
        this.events();
    }

    dom() {
        this.$triggers = $('*[data-popover]');
        // we do not preselect popovers to not depend on the popover class (this way, the popover works with any element)
    }

    events() {
        this.$triggers.off('click.Popover');
        this.$triggers.on('click.Popover', this.togglePopoverHandler.bind(this));
    }

    togglePopoverHandler(event) {
        event.preventDefault();

        const $trigger = $(event.currentTarget);
        
        if ($trigger.hasClass('is-active')) {
            this.closePopover($trigger);
        } else {
            this.openPopover($trigger);
        }
    }

    openPopover($trigger) {
        const popoverSelector = $trigger.data('popover');
        const $popover = $(popoverSelector);

        if ($popover.length < 1) return false;

        // add auto close event for specific trigger
        if ($trigger.data('popover-autoclose')) {
            $(document).off('click.Popover' + popoverSelector);
            $(document).on('click.Popover' + popoverSelector, (event) => {
                if(
                    (
                        !$trigger.is(event.target) && 
                        $trigger.has(event.target).length === 0
                    ) &&
                    (
                        !$popover.is(event.target) && 
                        $popover.has(event.target).length === 0
                    )
                ) {
                    this.closePopover($trigger)
                }
            });
        }

        // add close button event
        const $close = $popover.find('.popover-close');

        if ($close.length > 0) {
            $popover.addClass('has-close');

            $close.off('click.Popover' + popoverSelector);
            $close.on('click.Popover' + popoverSelector, (event) => {
                event.preventDefault();
                this.closePopover($trigger);
            });
        } else {
            $popover.removeClass('has-close');
        }

        // init popover
        this.$triggers.filter('[data-popover="' + popoverSelector + '"]').addClass('is-active');
        $popover.addClass('is-active');
        
        this.initPopper($trigger, $popover);

        return true;
    }

    closePopover($trigger) {
        const popoverSelector = $trigger.data('popover');
        const $popover = $(popoverSelector);

        if ($popover.length < 1) return false;

        // remove classes
        this.$triggers.filter('[data-popover="' + popoverSelector + '"]').removeClass('is-active');
        $popover.removeClass('is-active');

        // remove autoclose for specific trriger
        $(document).off('click.Popover' + popoverSelector);

        // destroy popper
        this.destroyPopper($trigger, $popover);
        
        return true;
    }

    initPopper($trigger, $popover) {
        if ($trigger.data('popover-popper')) {
            this.destroyPopper($trigger, $popover);
        }

        const placement = $trigger.data('popover-placement') || 'bottom';
        let offset = $trigger.data('popover-offset') || '0,16';
        let allowed = $trigger.data('popover-allowed') || 'top,bottom,left,right';
        let padding = $trigger.data('popover-padding') || '16';
        let strategy = $trigger.data('popover-strategy') || 'fixed';
        offset = offset.split(',').map(Number);
        allowed = allowed.split(',');
        padding = Number(padding);

        const popperInstance = createPopper($trigger[0], $popover[0], {
            placement: placement,
            strategy: strategy,
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: offset
                    }
                },
                {
                    name: 'flip',
                    options: {
                        allowedAutoPlacements: allowed,
                        rootBoundary: 'viewport'
                    }
                },
                {
                    name: 'preventOverflow',
                    options: {
                        altAxis: true,
                        rootBoundary: 'document',
                        padding: padding
                    },
                }
            ]
        });

        // save instance
        $trigger.data('popover-popper', popperInstance);
        $popover.data('popover-popper', popperInstance);
    }

    destroyPopper($trigger, $popover) {
        const popperInstance = $trigger.data('popover-popper');

        if (popperInstance) popperInstance.destroy();

        // delete instance
        $trigger.data('popover-popper', null);
        $popover.data('popover-popper', null);
    }
}

export default Popover;